import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TestGroup } from '../pages/orders/modules/order/models/test-group.modal';
import { TestGroupsApiService } from './test-group-api.service';

@Injectable({ providedIn: 'root' })
export class TestGroupService {
  private readonly api = inject(TestGroupsApiService);

  public getFavoriteTestGroups(practiceId: number, laboratoryFacilityId: number): Observable<TestGroup[]> {
    return this.api.getFavoriteTestGroups(practiceId, laboratoryFacilityId);
  }
}
